module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo LTCAT",
      "onRegister": (!_vm.validarPacote(27) ? null : _vm.onRegister),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcat,
      "onFilter": _vm.getLtcat,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3641a864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/index.vue
// module id = 1441
// module chunks = 45